/**
 * Grab specific indicator for editing
 * */
import { LINKS_KEY, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { clearMessages, createErrorMessages, createBackendErrorMessages, messagesReceived } from "./message";
import ObjectUtils from "../utils/ObjectUtils";
import rest from "../common/rest";
import { setPropertyValue } from "./fundingArea";
import { beginLoading, endLoading } from "./loadingSpinner";

const { getDeepProperty } = ObjectUtils;

const NEW_ACTION = "INDICATOR.NEW_ACTION";
const LOAD_ACTION = "INDICATOR.LOAD_ACTION";
const CLOSE_MODAL_ACTION = "INDICATOR.CLOSE_MODAL_ACTION";
const CHANGE_PROPERTY_ACTION = "INDICATOR.CHANGE_PROPERTY_ACTION";
const UPDATE_INDICATOR_DATA_ACTION = "INDICATOR.UPDATE_INDICATOR_DATA_ACTION";
const UPDATE_INDICATOR_WHOLE_LIST = "INDICATOR.UPDATE_INDICATOR_WHOLE_LIST";
const SAVE_SUCCESSFUL_ACTION = "INDICATOR.SAVE_SUCCESSFUL_ACTION";
const LOAD_ACTION_EDIT = "INDICATOR.LOAD_ACTION_EDIT";
const SORT_COLUMN_ACTION = "INDICATOR.SORT_COLUMN_ACTION";

export const LOADED = "loaded";
export const PROPERTY_ID = "propetyId";
export const INDICATOR_LIST = "indicatorList";
export const IS_NEW = "isNew";
export const SHOW_MODAL = "showModal";
export const INDICATOR_IDENTIFIER = "identifier";

export const INDICATOR_ID = "indicatorId";
export const INDICATOR_NAME = "indicatorName";
export const INDICATOR_SHORT_NAME = "indicatorShort";
export const INDICATOR_PROGRAM = "program";
export const INDICATOR_FUNDING_AREA = "fundingArea";

export const INDICATOR_LONG = "longName";
export const INDICATOR_SHORT = "shortName";
export const SORT_TABLE_INDICATOR = "sortTableIndicator";
export const SORT_TABLE_INDICATOR_BY = "sortTableIndicatorBy";

const initialState = {
  [INDICATOR_LIST]: [],
  [INDICATOR_ID]: "",
  [INDICATOR_SHORT_NAME]: "",
  [INDICATOR_NAME]: "",
  [IS_NEW]: false,
  [SORT_TABLE_INDICATOR]: false,
  [SHOW_MODAL]: false,
  [INDICATOR_FUNDING_AREA]: {},
  [INDICATOR_PROGRAM]: {},
  [SORT_TABLE_INDICATOR_BY]: "",
  [INDICATOR_LONG]: "",
  [INDICATOR_SHORT]: ""
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case NEW_ACTION:
      newState = Object.assign({}, state, initialState, {
        [INDICATOR_LIST]: state[INDICATOR_LIST],
        [INDICATOR_FUNDING_AREA]: null,
        [INDICATOR_PROGRAM]: null,
        [IS_NEW]: action[IS_NEW],
        [SHOW_MODAL]: action[SHOW_MODAL]
      });
      break;
    case CLOSE_MODAL_ACTION:
      newState = Object.assign({}, state, initialState, {
        [INDICATOR_LIST]: state[INDICATOR_LIST]
      });
      break;
    case CHANGE_PROPERTY_ACTION:
      newState = Object.assign({}, state, { [action[PROPERTY_ID]]: action[PROPERTY_VALUE] });
      break;
    case LOAD_ACTION:
      newState = Object.assign({}, state, {
        [INDICATOR_LIST]: action.indicatorList,
        [IS_NEW]: false,
        [SHOW_MODAL]: false
      });
      break;
    case LOAD_ACTION_EDIT:
      newState = Object.assign({}, state, {
        [INDICATOR_SHORT_NAME]: action.indicatorList.shortName,
        [INDICATOR_NAME]: action.indicatorList.longName,
        [INDICATOR_ID]: action.indicatorList.title,
        [INDICATOR_FUNDING_AREA]: action.indicatorList.fundingArea,
        [INDICATOR_PROGRAM]: action.indicatorList.program,
        [INDICATOR_IDENTIFIER]: action.indicatorList.identifier,
        [IS_NEW]: false,
        [SHOW_MODAL]: true
      });
      break;
    case UPDATE_INDICATOR_DATA_ACTION:
      newState = Object.assign({}, state, {
        [INDICATOR_FUNDING_AREA]: action[INDICATOR_FUNDING_AREA],
        [INDICATOR_PROGRAM]: action[INDICATOR_PROGRAM]
      });
      break;
    case UPDATE_INDICATOR_WHOLE_LIST:
      newState = Object.assign({}, state, {
        [INDICATOR_ID]: action[INDICATOR_ID],
        [INDICATOR_SHORT_NAME]: action[INDICATOR_SHORT_NAME],
        [INDICATOR_NAME]: action[INDICATOR_NAME],
        [INDICATOR_FUNDING_AREA]: action[INDICATOR_FUNDING_AREA],
        [INDICATOR_PROGRAM]: action[INDICATOR_PROGRAM]
      });
      break;
    case SAVE_SUCCESSFUL_ACTION:
      newState = Object.assign({}, state, {
        [INDICATOR_ID]: action[INDICATOR_ID],
        [INDICATOR_SHORT_NAME]: action[INDICATOR_SHORT_NAME],
        [INDICATOR_NAME]: action[INDICATOR_NAME],
        [INDICATOR_FUNDING_AREA]: action[INDICATOR_FUNDING_AREA],
        [INDICATOR_PROGRAM]: action[INDICATOR_PROGRAM]
      });
      break;
    case SORT_COLUMN_ACTION: {
      newState = Object.assign({}, state, initialState, {
        [INDICATOR_LIST]: state[INDICATOR_LIST],
        [SORT_TABLE_INDICATOR_BY]: action[SORT_TABLE_INDICATOR_BY],
        [SORT_TABLE_INDICATOR]: action[SORT_TABLE_INDICATOR]
      });
      break;
    }
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

export function loadIndicator(indicator) {
  return (dispatch) => {
    dispatch(beginLoading());
    rest.doGet(`/admin/indicators/${indicator.identifier}`).then(
      (json) => {
        if (json.identifier) {
          dispatch(loadSuccessfulEdit(json));
          dispatch(setPropertyValue("selectedFundingArea", "indicators", json.fundingArea));
          dispatch(setPropertyValue("selectedProgram", "indicators", json.program));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 *
 * Load full list of indicator
 * */
export function loadIndicatorListFilter() {
  let indicatorFilterLink = "/admin/indicators";

  return (dispatch) => {
    dispatch(beginLoading());
    rest.doGet(indicatorFilterLink).then(
      (json) => {
        if (json.indicators) {
          dispatch(loadSuccessful(json.indicators));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 * Change state after sorting
 * */
export function sortColumnIndicator(indicatorList, columnType, asc) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: SORT_COLUMN_ACTION,
      [INDICATOR_LIST]: indicatorList,
      [SORT_TABLE_INDICATOR]: asc,
      [SORT_TABLE_INDICATOR_BY]: columnType
    });
  };
}

/**
 * Create new indicator action
 */
export function newIndicator() {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: NEW_ACTION,
      [SHOW_MODAL]: true,
      [IS_NEW]: true
    });
    dispatch(setPropertyValue("selectedFundingArea", "indicators", null));
    dispatch(setPropertyValue("selectedProgram", "indicators", null));
    dispatch(clearMessages());
  };
}

/**
 * Load successful action
 */
export function loadSuccessful(indicator) {
  return {
    [TYPE_KEY]: LOAD_ACTION,
    [INDICATOR_LIST]: indicator
  };
}

/**
 * Load successful edit action
 */
export function loadSuccessfulEdit(indicator) {
  return {
    [TYPE_KEY]: LOAD_ACTION_EDIT,
    [INDICATOR_LIST]: indicator
  };
}

/**
 * Close modal
 * */
export function closeModalDialog() {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CLOSE_MODAL_ACTION
    });
    dispatch(clearMessages());
  };
}

/**
 * Trigger submit form
 * */
export function submitModalDialog() {
  return (dispatch, getState) => {
    let { indicatorId, indicatorShort, indicatorName } = getState().indicatorList,
      fundingArea = getDeepProperty(getState(), "fundingArea", "selectedFundingArea", "indicators"),
      indicatorProgram = getDeepProperty(getState(), "fundingArea", "selectedProgram", "indicators");

    /* If user not enter ID show error and prevent*/
    if (indicatorId === undefined || indicatorId === null || indicatorId === "") {
      dispatch(messagesReceived(createErrorMessages("indicatorList.id.empty")));
    } else {
      saveIndicator(indicatorId, indicatorShort, indicatorName, fundingArea, indicatorProgram)(dispatch);
    }
  };
}

/**
 * Take changed value
 * */
export function changeProperty(propetyId, propertyValue) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_ID]: propetyId,
      [PROPERTY_VALUE]: propertyValue
    });
  };
}

/**
 * Filter indicators according fundingArea and program
 * */
export function filterSelected(columnType, ascendingSort) {
  let sort = ascendingSort ? "-" : "",
    indicatorFilterLink = `/admin/indicators?sort=${sort + columnType}`;

  return (dispatch, getState) => {
    let fundingAreaId = getDeepProperty(
        getState(),
        "fundingArea",
        "selectedFundingArea",
        "indicatorsModalDialog",
        "id"
      ),
      programId = getDeepProperty(getState(), "fundingArea", "selectedProgram", "indicatorsModalDialog", "id");

    if (fundingAreaId || programId) {
      indicatorFilterLink = indicatorFilterLink + "&";
    }

    if (fundingAreaId) {
      indicatorFilterLink = indicatorFilterLink + "fundingArea=" + fundingAreaId + "&";
    }
    if (programId) {
      indicatorFilterLink = indicatorFilterLink + "program=" + programId + "&";
    }

    rest.doGet(indicatorFilterLink).then(
      (json) => {
        if (json.indicators) {
          dispatch(loadSuccessful(json.indicators));
          dispatch(sortColumnIndicator(json.indicators, columnType, !ascendingSort));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

/**
 * Add new / edit indicator
 * */
export function saveIndicator(indicatorId, indicatorShort, indicatorName, fundingArea, indicatorProgram, identifier) {
  const indicator = {};
  return (dispatch) => {
    /* Create object for to override one we have with */
    indicator.fundingArea = fundingArea;
    indicator.program = indicatorProgram;
    indicator.title = indicatorId;
    indicator.shortName = indicatorShort;
    indicator.longName = indicatorName;

    if (indicator.fundingArea) {
      /* Then edit */
      let link = `/admin/indicators`;
      //if identifier is undefined, we suppose it is a new survey, otherwise we believe it is an existing indicator.
      (!identifier
        ? rest.doPost(`${link}`, JSON.stringify(indicator))
        : rest.doPut(`${link}/${identifier}`, JSON.stringify(indicator))
      ).then(
        (json) => {
          if (json.identifier && json.fundingArea !== null) {
            dispatch(saveSuccessful(json.link, indicator));
            loadIndicatorListFilter()(dispatch);
          } else {
            dispatch(messagesReceived(createErrorMessages("indicatorList.fundingArea.empty")));
          }
        },
        (reason) => {
          dispatch(messagesReceived(createErrorMessages(`indicatorList.id.${reason.status}`)));
        }
      );
    } else {
      dispatch(messagesReceived(createErrorMessages("indicatorList.fundingArea.empty")));
    }
  };
}

/**
 * Fire new state if everything is ok with editing / creating new
 * */
export function saveSuccessful(link, indicator) {
  return {
    [TYPE_KEY]: SAVE_SUCCESSFUL_ACTION,
    [INDICATOR_SHORT_NAME]: indicator[INDICATOR_SHORT_NAME],
    [INDICATOR_NAME]: indicator[INDICATOR_NAME],
    [INDICATOR_ID]: indicator[INDICATOR_ID],
    [INDICATOR_FUNDING_AREA]: indicator[INDICATOR_FUNDING_AREA],
    [INDICATOR_PROGRAM]: indicator[INDICATOR_PROGRAM],
    [LINKS_KEY]: link
  };
}

export function filterSelectedArea(fundingArea, program) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: UPDATE_INDICATOR_DATA_ACTION,
      [INDICATOR_FUNDING_AREA]: fundingArea,
      [INDICATOR_PROGRAM]: program
    });
  };
}
